import { OFFER_MODEL_FALLBACK_IMAGES } from "../utils/offerHelpers";

export const PORTAL_VO_OFFERS = [
  {
    id: "vo-001",
    title: "Toyota Corolla 120H Active Tech",
    brand: "Toyota",
    model: "Corolla",
    price: 21990,
    year: 2022,
    mileage: 34800,
    location: "Madrid",
    color: "Blanco perlado",
    displacement: 1798,
    fuel: "Híbrido",
    power: "122 CV",
    seller: "Laura M.",
    hasGuaranteeSeal: true,
    portalScore: 97,
    warrantyMonths: 24,
    description: "Un solo dueño, historial completo y consumo muy contenido para uso diario.",
    image: OFFER_MODEL_FALLBACK_IMAGES["toyota corolla"],
  },
  {
    id: "vo-002",
    title: "Kia Niro HEV Drive",
    brand: "Kia",
    model: "Niro",
    price: 24950,
    year: 2023,
    mileage: 28900,
    location: "Valencia",
    color: "Gris lunar",
    displacement: 1580,
    fuel: "Híbrido",
    power: "141 CV",
    seller: "Carlos V.",
    hasGuaranteeSeal: false,
    portalScore: 95,
    warrantyMonths: 18,
    description: "Muy buen equilibrio entre espacio, eficiencia y etiqueta ECO para ciudad y viajes.",
    image: OFFER_MODEL_FALLBACK_IMAGES["kia niro"],
  },
  {
    id: "vo-003",
    title: "Volkswagen Golf Life 1.5 eTSI",
    brand: "Volkswagen",
    model: "Golf",
    price: 23450,
    year: 2023,
    mileage: 22100,
    location: "Barcelona",
    color: "Negro",
    displacement: 1498,
    fuel: "Gasolina MHEV",
    power: "130 CV",
    seller: "Sergio A.",
    hasGuaranteeSeal: false,
    portalScore: 94,
    warrantyMonths: 12,
    description: "Compacto premium-generalista con buen equipamiento y mantenimiento sellado.",
    image: OFFER_MODEL_FALLBACK_IMAGES["volkswagen golf"],
  },
  {
    id: "vo-004",
    title: "BYD Dolphin Comfort",
    brand: "BYD",
    model: "Dolphin",
    price: 26400,
    year: 2024,
    mileage: 11200,
    location: "Málaga",
    color: "Blanco",
    displacement: 0,
    fuel: "Eléctrico",
    power: "204 CV",
    seller: "Nuria P.",
    hasGuaranteeSeal: true,
    portalScore: 93,
    warrantyMonths: 24,
    description: "Eléctrico reciente, muy equipado y con batería en excelente estado certificado.",
    image: OFFER_MODEL_FALLBACK_IMAGES["byd dolphin"],
  },
  {
    id: "vo-005",
    title: "Seat León 1.5 eTSI FR",
    brand: "Seat",
    model: "León",
    price: 20100,
    year: 2022,
    mileage: 39800,
    location: "Sevilla",
    color: "Rojo deseo",
    displacement: 1498,
    fuel: "Gasolina MHEV",
    power: "150 CV",
    seller: "Miguel T.",
    hasGuaranteeSeal: false,
    portalScore: 89,
    warrantyMonths: 0,
    description: "Unidad muy cuidada con buen punto deportivo y coste razonable de uso.",
    image: OFFER_MODEL_FALLBACK_IMAGES["seat leon"],
  },
  {
    id: "vo-006",
    title: "BMW X1 sDrive18d",
    brand: "BMW",
    model: "X1",
    price: 29500,
    year: 2021,
    mileage: 58300,
    location: "Bilbao",
    color: "Blanco",
    displacement: 1995,
    fuel: "Diésel",
    power: "150 CV",
    seller: "Autoselect Norte",
    hasGuaranteeSeal: false,
    portalScore: 91,
    warrantyMonths: 12,
    description: "SUV premium con historial revisado y buena presentación para uso familiar o mixto.",
    image: OFFER_MODEL_FALLBACK_IMAGES["bmw x1"],
  },
  {
    id: "vo-007",
    title: "Renault Captur TCe Intens",
    brand: "Renault",
    model: "Captur",
    price: 17850,
    year: 2021,
    mileage: 41500,
    location: "Zaragoza",
    color: "Naranja atakama",
    displacement: 1333,
    fuel: "Gasolina",
    power: "130 CV",
    seller: "Paula G.",
    hasGuaranteeSeal: false,
    portalScore: 86,
    warrantyMonths: 0,
    description: "Crossover urbano bien mantenido, ideal para ciudad y uso versátil.",
    image: OFFER_MODEL_FALLBACK_IMAGES["renault captur"],
  },
  {
    id: "vo-008",
    title: "Skoda Octavia 2.0 TDI DSG",
    brand: "Skoda",
    model: "Octavia",
    price: 21900,
    year: 2020,
    mileage: 67200,
    location: "Valladolid",
    color: "Plata metalizada",
    displacement: 1968,
    fuel: "Diésel",
    power: "150 CV",
    seller: "Daniel R.",
    hasGuaranteeSeal: false,
    portalScore: 90,
    warrantyMonths: 12,
    description: "Muy buen maletero, consumo bajo y enfoque racional para carretera y familia.",
    image: OFFER_MODEL_FALLBACK_IMAGES["skoda octavia"],
  },
  {
    id: "vo-009",
    title: "Hyundai Kona Electric Maxx",
    brand: "Hyundai",
    model: "Kona",
    price: 25500,
    year: 2023,
    mileage: 18700,
    location: "Alicante",
    color: "Gris cyber",
    displacement: 0,
    fuel: "Eléctrico",
    power: "204 CV",
    seller: "Marina S.",
    hasGuaranteeSeal: false,
    portalScore: 92,
    warrantyMonths: 24,
    description: "Muy equilibrado para ciudad y periferia, con batería revisada y carga rápida.",
    image: OFFER_MODEL_FALLBACK_IMAGES["hyundai kona"],
  },
  {
    id: "vo-010",
    title: "Audi A3 Sportback S line",
    brand: "Audi",
    model: "A3",
    price: 28900,
    year: 2022,
    mileage: 26500,
    location: "Pamplona",
    color: "Negro brillante",
    displacement: 1498,
    fuel: "Gasolina",
    power: "150 CV",
    seller: "Premium Selection",
    hasGuaranteeSeal: true,
    portalScore: 92,
    warrantyMonths: 12,
    description: "Compacto premium muy bien presentado, ideal si buscas imagen y uso diario fino.",
    image: OFFER_MODEL_FALLBACK_IMAGES["audi a3"],
  },
  {
    id: "vo-011",
    title: "MG4 Luxury Extended Range",
    brand: "MG",
    model: "MG4",
    price: 23900,
    year: 2024,
    mileage: 9800,
    location: "Murcia",
    color: "Naranja",
    displacement: 0,
    fuel: "Eléctrico",
    power: "204 CV",
    seller: "Álvaro C.",
    hasGuaranteeSeal: true,
    portalScore: 94,
    warrantyMonths: 24,
    description: "Muy buen precio para el equipamiento que ofrece y con etiqueta CERO para ZBE.",
    image: OFFER_MODEL_FALLBACK_IMAGES["mg4"],
  },
  {
    id: "vo-012",
    title: "Peugeot 3008 BlueHDi Allure",
    brand: "Peugeot",
    model: "3008",
    price: 22800,
    year: 2021,
    mileage: 54400,
    location: "Granada",
    color: "Blanco nacarado",
    displacement: 1499,
    fuel: "Diésel",
    power: "130 CV",
    seller: "Irene F.",
    hasGuaranteeSeal: false,
    portalScore: 88,
    warrantyMonths: 0,
    description: "SUV cómodo y amplio para familia, con consumo contenido y buen maletero.",
    image: OFFER_MODEL_FALLBACK_IMAGES["peugeot 3008"],
  },
  {
    id: "vo-013",
    title: "Volvo XC40 B3 Core",
    brand: "Volvo",
    model: "XC40",
    price: 31200,
    year: 2023,
    mileage: 20800,
    location: "A Coruña",
    color: "Azul fjord",
    displacement: 1969,
    fuel: "Gasolina MHEV",
    power: "163 CV",
    seller: "Nordic Cars",
    hasGuaranteeSeal: false,
    portalScore: 93,
    warrantyMonths: 18,
    description: "SUV premium centrado en seguridad y confort, con muy buen estado interior.",
    image: OFFER_MODEL_FALLBACK_IMAGES["volvo xc40"],
  },
  {
    id: "vo-014",
    title: "Nissan Qashqai DIG-T N-Connecta",
    brand: "Nissan",
    model: "Qashqai",
    price: 21450,
    year: 2022,
    mileage: 37100,
    location: "Santander",
    color: "Gris grafito",
    displacement: 1332,
    fuel: "Gasolina MHEV",
    power: "140 CV",
    seller: "Rubén H.",
    hasGuaranteeSeal: false,
    portalScore: 87,
    warrantyMonths: 0,
    description: "Muy equilibrado para familia y carretera, con buena altura y confort de marcha.",
    image: OFFER_MODEL_FALLBACK_IMAGES["nissan qashqai"],
  },
  {
    id: "vo-015",
    title: "Mercedes Clase A 200 Progressive",
    brand: "Mercedes",
    model: "Clase A",
    price: 29990,
    year: 2022,
    mileage: 24900,
    location: "Palma",
    color: "Plata iridio",
    displacement: 1332,
    fuel: "Gasolina",
    power: "163 CV",
    seller: "Isabel R.",
    hasGuaranteeSeal: false,
    portalScore: 91,
    warrantyMonths: 12,
    description: "Premium compacto muy bien equipado, con presentación cuidada y mantenimiento reciente.",
    image: OFFER_MODEL_FALLBACK_IMAGES["mercedes clase a"],
  },
  {
    id: "vo-016",
    title: "Dacia Duster ECO-G Journey",
    brand: "Dacia",
    model: "Duster",
    price: 18950,
    year: 2023,
    mileage: 19400,
    location: "Toledo",
    color: "Verde cedro",
    displacement: 999,
    fuel: "GLP",
    power: "100 CV",
    seller: "Javier L.",
    hasGuaranteeSeal: false,
    portalScore: 88,
    warrantyMonths: 12,
    description: "Opción muy racional en coste de uso, altura libre y mantenimiento sencillo.",
    image: OFFER_MODEL_FALLBACK_IMAGES["dacia duster"],
  },
  {
    id: "vo-017",
    title: "Volkswagen T-Roc Advance 1.5 TSI",
    brand: "Volkswagen",
    model: "T-Roc",
    price: 27990,
    rentingAvailable: true,
    rentingMonthly: 479,
    year: 2023,
    mileage: 19800,
    location: "Madrid",
    color: "Blanco",
    displacement: 1498,
    fuel: "Gasolina",
    power: "150 CV",
    seller: "PopCar Store",
    hasGuaranteeSeal: true,
    portalScore: 96,
    warrantyMonths: 24,
    description: "Disponible para compra o renting con cuota competitiva por debajo de 500 €/mes.",
    imageFolder: "volkswagen-t-roc-advance-1-5-tsi",
    image: OFFER_MODEL_FALLBACK_IMAGES["volkswagen golf"],
  },
];
